export const AREA_URLS = {
  contabilita: process.env.REACT_APP_CONTABILITA_URL,
  tesoreria: process.env.REACT_APP_TESORERIA_URL,
  produzione: process.env.REACT_APP_PRODUZIONE_URL,
  risorice: process.env.REACT_APP_RISORICE_URL,
  posta: process.env.REACT_APP_POSTA_URL,
  paghe: process.env.REACT_APP_PAGHE_URL,
  sohelp: process.env.REACT_APP_SOHELP_URL,
  paqway: process.env.REACT_APP_PAQWAY_URL,
};
